import React from "react";
import {
  Box,
  Chip,
  Col,
  FabButton,
  Flex,
  Row,
  Typography,

} from "../../../ppui";
import { AllowanceBox } from "../../style";
import { TbAlertTriangle, TbPencil } from "react-icons/tb";
const AllowanceList = ({ isFetching, allowanceListResponse, setAllowance, setAllowancedialogOpen ,setErrors}) => {
  if (isFetching) {
    throw new Promise(() => { });
  }

  return (
    <Flex gap={20} direction={"column"}>
      {allowanceListResponse?.length > 0 ?
        allowanceListResponse?.map((it) => (
          <AllowanceBox key={it?.allowanceName}>
            <Row alignItems="center">
         

              <Col xs={12}>
              <Flex alignItems="center" gap={{ md: 20, lg: 40, xxl: 60 }}>
                <Box>
                  <Box className="label">Allowance</Box>
                  <Box className="value">{it?.allowanceName}</Box>
                </Box>

                <Box>
                  <Box className="label"> Type</Box>
                  <Box className="value">{it?.allowanceType}</Box>
                </Box>
                <Box>
                  <Box className="label"> Ammount</Box>
                  <Box className="value">{it?.allowanceValue}</Box>
                </Box>
                <Box>
                  <Box className="label"> No Work No Pay</Box>
                  <Box className="value">{it?.noWorkNoPay ? "Yes" : "No"}</Box>
                </Box>
                <Box>
                  <Box className="label"> ESI Wages</Box>
                  <Box className="value">{it?.isEsiWages ? "Yes" : "No"}</Box>
                </Box>
                <Box>
                  <Box className="label"> EPF Wages</Box>
                  <Box className="value">{it?.isEpfWages ? "Yes" : "No"}</Box>
                </Box>
                <Box>
                  <Box className="label">Status</Box>
                  <Chip
                    color="success"
                    label="Active"
                    onClick={() => {}}
                    size="sm"
                  />
                </Box>

                <Box ml="auto">
                  <FabButton
                    icon={<TbPencil />}
                    onClick={() => {
                      setAllowancedialogOpen(true);
                      setAllowance(it);
                      setErrors({})
                    }}
                    variant="filled"
                    shape="box"
                  />
                </Box>
              </Flex>
            </Col>
         
            </Row>
          </AllowanceBox>
        ))
        :
        <AllowanceBox >
          <Typography variant="body1" display="flex" gap={10} alignItem="center" mb={"0"} p={15}>
            <TbAlertTriangle />
            No predefined allowances available
          </Typography>
        </AllowanceBox>


      }


    </Flex>
  )
}

export default AllowanceList